import { render } from "./ModalDataGenius.vue?vue&type=template&id=7fd7c92e&scoped=true"
import script from "./ModalDataGenius.vue?vue&type=script&lang=js"
export * from "./ModalDataGenius.vue?vue&type=script&lang=js"

import "./ModalDataGenius.vue?vue&type=style&index=0&id=7fd7c92e&scoped=true&lang=css"

import exportComponent from "/home/andre_merino/aihuk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fd7c92e"]])

export default __exports__